/** Playwright global setup indirectly references this file, don't access browser APIs unless they exist */
const location: Partial<Location> = globalThis.window ? window.location : {};

const auth0CallbackUrl = `${location.origin}/auth/callback`;
const auth0ReturnUrl = `${location.origin}/auth/login`;

/**
 * import.meta.env should not be accessed directly, instead use ENVIRONMENT
 */
// prettier-ignore
export const ENVIRONMENT = {
  NODE_ENV: import.meta.env.NODE_ENV,
  HOST_TYPE: import.meta.env.NX_PUBLIC_HOST_TYPE,
  IS_DEV:
    import.meta.env.NX_PUBLIC_HOST_TYPE === 'development' ||
    import.meta.env.NX_PUBLIC_HOST_TYPE === 'local',
  IS_LOCAL_DEV:
    import.meta.env.NX_PUBLIC_IS_CI !== 'true' &&
    location?.hostname === 'localhost',
  IS_PLAYWRIGHT:
    import.meta.env.NX_PUBLIC_IS_CI === 'true' &&
    location?.hostname === 'localhost',
  IS_CI: import.meta.env.NX_PUBLIC_IS_CI === 'true',
  /** 
   * True if running rules service locally
   * Rules service will call local service instead of dev server
   */
  LOCAL_RULES: import.meta.env.NX_PUBLIC_LOCAL_RULES === 'true',
  LOCAL_LAMBDAS: import.meta.env.NX_PUBLIC_LOCAL_LAMBDAS === 'true',
  AUTH0_DOMAIN: import.meta.env.NX_PUBLIC_AUTH0_DOMAIN,
  AUTH0_CLIENT_ID: import.meta.env.NX_PUBLIC_AUTH0_CLIENT_ID,
  AUTH0_REALM: import.meta.env.NX_PUBLIC_AUTH0_REALM,
  AUTH0_API_AUDIENCE: import.meta.env.NX_PUBLIC_AUTH0_API_AUDIENCE,
  BASE_URL: import.meta.env.NX_PUBLIC_BASE_URL,
  SENTRY_DSN: import.meta.env.NX_PUBLIC_SENTRY_DSN,
  TENANT_KEY: import.meta.env.NX_PUBLIC_TENANT_KEY,
  USER_KEY: import.meta.env.NX_PUBLIC_USER_KEY,
  DOCUSIGN_CLIENT_ID: import.meta.env.NX_PUBLIC_DOCUSIGN_CLIENT_ID,
  HEAP_APP_ID: import.meta.env.NX_PUBLIC_HEAP_APP_ID,
  LAUNCH_DARKLY_CLIENT_ID:
    import.meta.env.NX_PUBLIC_LAUNCH_DARKLY_CLIENT_ID || '6334b29de243b410eeb37ffc',
  APPCUE_APP_ID: import.meta.env.NX_PUBLIC_APPCUE_APP_ID,
  IS_TEST: import.meta.env.TEST === 'true' || import.meta.env.VITEST === 'true' || !!import.meta.env.VITEST_WORKER_ID || !!import.meta.env.NX_JEST_WORKER_ID,
  PDFJS_WORKER_URL: new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
  ).toString(),
  CHAT_URL: import.meta.env.NX_PUBLIC_CHAT_URL,
  SYSTEM_USER_ID: 'usr_qDfP1sOyHShW2oGZ',
} as const;

export const AUTH0 = {
  domain: ENVIRONMENT.AUTH0_DOMAIN || '',
  clientId: ENVIRONMENT.AUTH0_CLIENT_ID || '',
  callbackUrl: auth0CallbackUrl,
  realm: ENVIRONMENT.AUTH0_REALM,
  apiAudience: ENVIRONMENT.AUTH0_API_AUDIENCE,
  scope: 'openid profile email offline_access', // defaulted `openid profile email`
  responseType: 'token id_token',
  googleConnectionName: 'google-oauth2',
  returnTo: auth0ReturnUrl,
};

export const MARKETING_WEBSITE_URL = 'https://monetizenow.io';

export const SENTRY = {
  dsn: ENVIRONMENT.SENTRY_DSN,
};

export const KEYS = {
  tenantKey: ENVIRONMENT.TENANT_KEY || '',
  userKey: ENVIRONMENT.USER_KEY || '',
};

export const RELEASE = {
  releaseVersion:
    import.meta.env.NX_PUBLIC_RELEASE_VERSION || 'monetize-ui@local',
};

export const DOCUSIGN = {
  clientId:
    ENVIRONMENT.DOCUSIGN_CLIENT_ID || 'd751511b-1158-47fd-aaf6-a95556a65fda',
};

export const METABASE_CONFIG = {
  baseUrl: 'https://reporting.monetizeplatform.com',
  embeddedUrl: 'https://reporting.monetizeplatform.com/auth/sso',
  logoutUrl: 'https://reporting.monetizeplatform.com/auth/logout',
  appearance: {
    return_to: `/?${new URLSearchParams({
      action_buttons: 'true',
      additional_info: 'true',
      breadcrumbs: 'true',
      header: 'true',
      // locale
      new_button: 'true',
      search: 'true',
      side_nav: 'true',
      top_nav: 'true',
    }).toString()}`,
  },
};

export const HEAP_CONFIG = {
  appId: ENVIRONMENT.HEAP_APP_ID,
};
